import React from 'react'
import {Modal, ModalBody, ModalHeader, ModalTitle} from 'react-bootstrap'

const AddEditModal = ({AddEditShow, setAddEditShow,title,handleClose,children}) => {
  return <Modal className='category-modal' 
    show={AddEditShow} 
    onHide={handleClose} 
    style={{backdropFilter: 'blur(2px)'}}
    backdrop="static"
    keyboard={false}
    >
        <ModalHeader closeButton>
        <ModalTitle>
            {title}
        </ModalTitle>
        </ModalHeader>
        <ModalBody>
        {children}
        </ModalBody>
    </Modal>
}

export default AddEditModal